'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvGames = function AvGames(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M15 7.5V2H9v5.5l3 3 3-3zM7.5 9H2v6h5.5l3-3-3-3zM9 16.5V22h6v-5.5l-3-3-3 3zM16.5 9l-3 3 3 3H22V9h-5.5z' })
  );
};
AvGames = (0, _pure2.default)(AvGames);
AvGames.displayName = 'AvGames';
AvGames.muiName = 'SvgIcon';

exports.default = AvGames;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/svg-icons/av/games.js
 ** module id = 1663
 ** module chunks = 0
 **/